import React, { useEffect, useState } from "react";

const PromoStrip = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [stripHeight, setStripHeight] = useState(0);

  useEffect(() => {
    const strip = document.getElementById("promo-strip");

    const handleScroll = () => {
      if (!strip) return;

      const rect = strip.getBoundingClientRect();

      if (rect.top <= -5 && !isFixed) {
        setIsFixed(true);
      } else if (rect.top > 5 && isFixed) {
        setIsFixed(false);
      }
    };

    const handleResize = () => {
      if (strip) {
        setStripHeight(strip.offsetHeight);
      }
    };

    handleScroll();
    handleResize();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div
        id="promo-strip"
        style={{
         background: "linear-gradient(90deg, rgb(13, 67, 133), rgb(48 113 189))",
          padding: "12px 15px",
          position: isFixed ? "fixed" : "relative",
          top: 80,
          left: 0,
          right: 0,
          zIndex: 999,
          textAlign: "center",
          boxShadow: isFixed ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
          transition: "all 0.3s ease",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <span
            style={{
              color: "#fff",
              fontSize: window.innerWidth <= 767 ? "13px" : "15px",
              fontWeight: "500",
            }}
          >
            ⚡ Get Extra 5% OFF on DC Fast Charger Dual Gun 240kW
          </span>

          <span
            style={{
              background: "#fff",
              color: "#ff0000",
              padding: "4px 10px",
              borderRadius: "20px",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            EXTRA 5
          </span>

          <a
            href="/product-details/dc-fast-charger-dual-gun-240kw-wi-fi/TCP-240-D-0-002"
            style={{
              background: "#000",
              color: "#fff",
              padding: "6px 14px",
              borderRadius: "20px",
              textDecoration: "none",
              fontSize: "13px",
              fontWeight: "500",
              transition: "0.3s",
            }}
            onMouseOver={(e) => (e.target.style.background = "#333")}
            onMouseOut={(e) => (e.target.style.background = "#000")}
          >
            Shop Now →
          </a>
        </div>
      </div>

      {/* Spacer */}
      {isFixed && <div style={{ height: `${stripHeight}px` }} />}
    </>
  );
};

export default PromoStrip;
